import { trackPageAction } from "lib/analytics/core/actions";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { TYPO } from "styles/Typo";
import { KOREA, US } from "utils/constant/ITME_INFO";

interface Props {
  hidden?: boolean;
  isActive: boolean;
  setIsActive: (value: boolean) => void;
  smallVer?: boolean;
  cat?: string;
  loc?: string;
}

function InterestToggleButton({
  hidden,
  isActive,
  setIsActive,
  cat,
  loc,
}: Props) {
  const router = useRouter();
  useEffect(() => {
    if (router.locale === "ko") {
      if (cat === "Stock" && loc === US) {
        setIsActive(false);
      } else setIsActive(true);
    }
    if (router.locale === "en") {
      setIsActive(true);
    }
  }, []);

  const basicStyle =
    "w-[60px] h-[34px] px-1 rounded-[10px] items-center inline-flex";

  return (
    <div
      className={`${hidden && "hidden"} relative cursor-pointer`}
      onClick={() => {
        trackPageAction("toggle_won");
        setIsActive(!isActive);
      }}
      data-gtm-id={`watchlist-toggle-btn`}
    >
      <div className="w-fit h-[24px] p-[2px] relative bg-grayOpacity10 rounded-[6px] cursor-pointer whitespace-nowrap flex items-center">
        <div
          className={`${
            !isActive ? "text-gray70 bg-floatBackground" : "text-gray70"
          } h-full px-1 rounded-[5px] justify-center items-center flex text-center`}
        >
          <span className="text-center text-[13px] font-normal leading-[13px] ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
            >
              <path
                d="M3.42171 12C3.20977 12 3.03212 11.9361 2.88875 11.8083C2.74538 11.6806 2.6737 11.5222 2.6737 11.3333V10.5667C2.11269 10.4556 1.62024 10.2611 1.19637 9.98333C0.772495 9.70555 0.429656 9.31667 0.167851 8.81667C0.0805826 8.66111 0.0774659 8.49722 0.158501 8.325C0.239536 8.15278 0.386022 8.02778 0.597959 7.95C0.772495 7.88333 0.953265 7.88611 1.14027 7.95833C1.32727 8.03055 1.47064 8.15 1.57038 8.31667C1.78231 8.65 2.05035 8.90278 2.37449 9.075C2.69863 9.24722 3.09757 9.33333 3.57131 9.33333C4.08246 9.33333 4.51568 9.23056 4.87099 9.025C5.22629 8.81944 5.40395 8.5 5.40395 8.06667C5.40395 7.67778 5.26681 7.36944 4.99254 7.14167C4.71827 6.91389 4.08246 6.65556 3.0851 6.36667C2.01295 6.06667 1.2774 5.70833 0.878464 5.29167C0.479523 4.875 0.280053 4.36667 0.280053 3.76667C0.280053 3.04444 0.541858 2.48333 1.06547 2.08333C1.58908 1.68333 2.12515 1.45556 2.6737 1.4V0.666667C2.6737 0.477778 2.74538 0.319444 2.88875 0.191667C3.03212 0.0638889 3.20977 0 3.42171 0C3.63365 0 3.8113 0.0638889 3.95467 0.191667C4.09804 0.319444 4.16972 0.477778 4.16972 0.666667V1.4C4.64347 1.46667 5.05487 1.60278 5.40395 1.80833C5.75302 2.01389 6.03976 2.26667 6.26416 2.56667C6.37637 2.71111 6.39818 2.87222 6.32962 3.05C6.26105 3.22778 6.12079 3.35556 5.90886 3.43333C5.73432 3.5 5.55355 3.50278 5.36655 3.44167C5.17954 3.38056 5.00501 3.27222 4.84294 3.11667C4.68087 2.96111 4.49075 2.84167 4.27258 2.75833C4.05441 2.675 3.78325 2.63333 3.45911 2.63333C2.91057 2.63333 2.49293 2.74167 2.20619 2.95833C1.91945 3.175 1.77608 3.44444 1.77608 3.76667C1.77608 4.13333 1.96308 4.42222 2.33709 4.63333C2.7111 4.84444 3.35938 5.06667 4.28193 5.3C5.14214 5.52222 5.79354 5.875 6.23611 6.35833C6.67869 6.84167 6.89998 7.4 6.89998 8.03333C6.89998 8.82222 6.63817 9.42222 6.11456 9.83333C5.59095 10.2444 4.94267 10.5 4.16972 10.6V11.3333C4.16972 11.5222 4.09804 11.6806 3.95467 11.8083C3.8113 11.9361 3.63365 12 3.42171 12Z"
                fill="#8B95A1"
              />
            </svg>
          </span>
        </div>
        <div
          className={` ${
            isActive ? "text-gray70 bg-floatBackground" : "text-gray70"
          } h-full px-1  rounded-[5px] justify-center items-center flex text-center`}
        >
          <span className="text-center text-[13px] font-normal leading-[13px]">
            원
          </span>
        </div>
      </div>
    </div>
  );
}

export default InterestToggleButton;
